export const environment = {
    trazeApi: {
        host: 'https://dev.trazeapi.com/api'
    },
    trazeApiImages: {
        host: 'https://dev.trazeapi.com/image'
    },
    apiUrl: 'https://api-elite-test.trazeapp.com'
};
